const handler = ( $ ) => {
	const doScroll = function ( sectionID, offset = 0 ) {
		const $section = $( '#' + sectionID );

		if ( $section.length ) {
			$( 'html, body' ).animate(
				{
					scrollTop: $section.offset().top - offset,
				},
				800,
				function () {
					// Add hash (#) to URL when done scrolling (default click behavior)
					window.location.hash = '#!/' + sectionID;
				}
			);
		}
	};

	// one-page navigation

	const hash = window.location.hash;
	// if page URL contains one-page hash
	if ( hash.indexOf( '#!/' ) !== -1 ) {
		const linkParts = hash.split( '#!/' ),
			sectionID = linkParts[ 1 ],
			$section = $( '#' + sectionID );

		if ( $section.length ) {
			let offset = 0;

			if ( sectionID.includes( 'accordion' ) ) {
				$( '#' + sectionID ).trigger( 'click' );
				offset = 80;
			}

			setTimeout( function () {
				doScroll( sectionID, offset );
			}, 400 );
		}
	}

	$( 'a' ).on( 'click', function ( e ) {
		const $link = $( this ),
			url = $link.attr( 'href' );

		// is one page link
		if ( url.substring(0, 3) == '#!/' ) {
			e.preventDefault();

			const linkParts = url.split( '#!/' ),
				sectionID = linkParts[ 1 ],
				$section = $( '#' + sectionID );

			if ( $section.length ) {

				let offset = 0;

				if ( sectionID.includes( 'accordion' ) ) {
					$section.trigger( 'click' );
					offset = 80;
				}

				setTimeout( function () {
					doScroll( sectionID, offset );
				}, 400 );
				
				return false;
			}
		}
	} );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
